var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWinHeadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.59814 7C3.59814 8.5913 4.23029 10.1174 5.3555 11.2426C6.48072 12.3679 8.00685 13 9.59814 13C11.1894 13 12.7156 12.3679 13.8408 11.2426C14.966 10.1174 15.5981 8.5913 15.5981 7C15.5981 5.4087 14.966 3.88258 13.8408 2.75736C12.7156 1.63214 11.1894 1 9.59814 1C8.00685 1 6.48072 1.63214 5.3555 2.75736C4.23029 3.88258 3.59814 5.4087 3.59814 7Z",
    stroke: "#76808F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.598 13L12.998 18.89L14.596 15.657L18.194 15.889L14.794 10M4.4 10L1 15.89L4.598 15.657L6.196 18.889L9.596 13",
    stroke: "#76808F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinHeadIcon);
export default __webpack_public_path__ + "static/media/win_head_icon.e2ef3b7c3f43c5333c209b4d09021570.svg";
export { ForwardRef as ReactComponent };